//用户信息

export default {
  //namespaced 开启namespaced
  namespaced: true,
  //action 响应组件动作 逻辑写在这
  actions: {
    //写入用户信息
    setUser(context, value) {
      context.commit('SET_USER', value)
    }
  },
  //mutation 处理数据 不要写逻辑
  mutations: {
    //写入用户信息
    SET_USER(state, value) {
      state.token = value.token
      state.userName = value.username
      state.userRole = value.role
      state.userRoleId = value.roleId
      state.userId = value.id
      state.expireTime = value.expireTime
      state.salesName = value.salesName
      state.rolePowers=value.rolePowers
    }
  },
  //state 数据/状态
  state: {
    token: 'NA',
    expireTime: 0,
    userName: 'NA',
    userRole: 'NA',
    userRoleId: 0,
    userId: 0,
    salesName: 'NA',
    rolePowers:[],
  },
  //getters 用于state后续数据加工
  getters: {
    getToken(state) {
      if (state.expireTime < Date.now()) {
        return 'NA'
      } else {
        return state.token
      }

    }
  },
}